import { get } from 'env-var';
import { SettingsValueProps } from './components/settings/type';

// CODE
// ----------------------------------------------------------------------

export const config = {
  auth0: {
    domain: get('REACT_APP_AUTH0_DOMAIN').required().asString(),
    clientId: get('REACT_APP_AUTH0_CLIENT_ID').required().asString(),
    audience: get('REACT_APP_AUTH0_AUDIENCE').required().asString(),
  },
  intercom: {
    appId: get('REACT_APP_INTERCOM_APP_ID').required().asString(),
  },
  lovage: {
    apiUrl: get('REACT_APP_LOVAGE_API_URL').required().asString(),
  },
  logrocket: {
    appId: get('REACT_APP_LOGROCKET_APP_ID').required().asString(),
  },
  muix: {
    pro_key: get('REACT_APP_MUIX_PRO_KEY').required().asString(),
  },
  segment: {
    writeKey: get('REACT_APP_SEGMENT_WRITE_KEY').required().asString(),
  },
  sentry: {
    dsn: get('REACT_APP_SENTRY_DSN').required().asString(),
  },
  datadog: {
    applicationId: get('REACT_APP_DATADOG_APP_ID').required().asString(),
    clientToken: get('REACT_APP_DATADOG_CLIENT_TOKEN').required().asString(),
    site: get('REACT_APP_DATADOG_SITE').required().asString(),
    env: get('NODE_ENV').required().asString(),
    service: 'dashboard',
    sampleRate: 100,
    sessionReplaySampleRate: 20,
    trackInteractions: true,
    trackLongTasks: true,
    trackResources: true,
    defaultPrivacyLevel: 'mask-user-input' as any,
    allowTracingOrigins: [get('REACT_APP_LOVAGE_API_URL').required().asString()],
  }
};

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you set settings.
// ----------------------------------------------------------------------

export const defaultSettings: SettingsValueProps = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeColorPresets: 'default',
  themeLayout: 'horizontal',
  themeStretch: false,
};
